import React from "react";
import "../App.css";
import noData from "../assets/si_alert-fill.svg";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import dayjs from "dayjs";

const ReportsData = ({ data, startDate, endDate, fetchData, activeFilter,   handleApplyFilters, selectedSuggestions, orderedWeekDays ,isFilterOpen, setIsFilterOpen, isBothSelected,dropdownRef,tempSelectedFilters, handleCheckboxChange,currentFilter }) => {
  const isDateRangeSelected = startDate && endDate;
  const isSuggestionsEmpty = !selectedSuggestions || selectedSuggestions.length === 0;
  const isDataEmpty = !data || !data.emp_report || Object.keys(data.emp_report).length === 0;

// Convert "HH:MM" (ignore seconds) -> decimal hours
const timeToDecimal = (timeStr) => {
  if (!timeStr) return 0;
  const [hh, mm] = timeStr.split(":").map(Number);
  const decimal = hh + mm / 60;
  return decimal.toFixed(2); // keep 2 decimals
};

  // Helper: Get actual date range between startDate and endDate
const getDatesInRange = (start, end) => {
  const dates = [];
  let current = dayjs(start);
  const endDate = dayjs(end);

  while (current.isSameOrBefore(endDate)) {
    dates.push(current);
    current = current.add(1, "day");
  }

  return dates;
};


  const actualDateRange = isDateRangeSelected ? getDatesInRange(startDate, endDate) : [];
  const isSingleDaySelected = actualDateRange.length === 1;

  // Show full week headers when no data is available
  if (!isDateRangeSelected || isSuggestionsEmpty ) {
    return (
      <table className="w-[99%] ml-1 rounded-[10px]  shadow-custom-light border-collapse bg-[#D9D9D980] ">
        <thead className="rounded-t-[10px] bg-gray-200 ">
          <tr className="border-b border-gray-300  text-[#900] ">
            <th className="py-3 font-Font1 flex flex-row items-center text-[12px] opacity-40 font-semibold tracking-[0.2px] uppercase pl-6 w-[20%] text-start rounded-tl-[10px]">
              Employee/Equipment
            <div className="relative z-20 " ref={dropdownRef}>
          <div
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            className="  rounded-md cursor-pointer "
          >
            <FilterAltIcon className="w-4 h-4 "  />
          </div>

          {isFilterOpen && (
<div className="fixed z-50 mt-2 bg-white shadow-md border rounded-md p-4 w-44" style={{ top: dropdownRef.current?.getBoundingClientRect().bottom + window.scrollY, left: dropdownRef.current?.getBoundingClientRect().left + window.scrollX }}>              {currentFilter.map((filter) => (
                <label key={filter.label} className="flex items-center gap-2 mb-2">
         <input
  type="checkbox"
  checked={tempSelectedFilters.includes(filter.value)}
  onChange={() => handleCheckboxChange(filter.value)}
  className="cursor-pointer"
/>


               <span className="font-Font1 ">{filter.label === 'EMP' ? 'Employee' : filter.label === 'EQP' ? 'Equipment' : filter.label}</span>

                </label>
              ))}
             

              <button
                onClick={handleApplyFilters}
  className={`mt-2 w-[80px] ml-6 px-3 py-2 rounded-md text-xs font-inter 
    ${isBothSelected ? 'bg-[#900] opacity-40 text-white' : 'bg-[#900] text-white'}`}              >
                Apply
              </button>
        
            </div>
          )}
            </div>
            </th>

            <th className="p-3 font-Font1 text-[12px] opacity-40 font-semibold tracking-[0.2px] pl-6 uppercase w-[16%] text-start">
              Total Hours
            </th>
            <th className="p-1 font-Font1 text-[12px] opacity-40 font-semibold tracking-[0.2px] uppercase w-[18%] text-start">
              Total Per Diem
            </th>
            {orderedWeekDays.map((day, index) => (
              <th
                key={day}
                className={`p-3 font-Font1 text-[12px] opacity-40 font-semibold tracking-[0.2px] uppercase text-start ${
                  index === orderedWeekDays.length - 1 ? "rounded-tr-[10px]" : ""
                }`}
              >
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              colSpan={3 + orderedWeekDays.length}
              className="p-4 text-md font-semibold text-[#000000] font-inter text-center text-gray-500"
            >
              <div className="flex items-center justify-center gap-2">
                <img src={noData} alt="No data" className="w-5 h-5" />
                <span className="text-black uppercase text-xs">Please Select Job ID and date range</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

   if (!isDateRangeSelected || isSuggestionsEmpty || isDataEmpty) {
    return (
      <table className="w-[99%] ml-1 rounded-[10px]  shadow-custom-light border-collapse bg-[#D9D9D980] ">
        <thead className="rounded-t-[10px] bg-gray-200 ">
          <tr className="border-b border-gray-300  text-[#900] ">
            <th className="py-3 font-Font1 flex flex-row items-center text-[12px] opacity-40 font-semibold tracking-[0.2px] uppercase pl-6 w-[20%] text-start rounded-tl-[10px]">
              Employee/Equipment
            <div className="relative z-20 " ref={dropdownRef}>
          <div
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            className="  rounded-md cursor-pointer "
          >
            <FilterAltIcon className="w-4 h-4 "  />
          </div>

          {isFilterOpen && (
<div className="fixed z-50 mt-2 bg-white shadow-md border rounded-md p-4 w-44" style={{ top: dropdownRef.current?.getBoundingClientRect().bottom + window.scrollY, left: dropdownRef.current?.getBoundingClientRect().left + window.scrollX }}>              {currentFilter.map((filter) => (
                <label key={filter.label} className="flex items-center gap-2 mb-2">
         <input
  type="checkbox"
  checked={tempSelectedFilters.includes(filter.value)}
  onChange={() => handleCheckboxChange(filter.value)}
  className="cursor-pointer"
/>


               <span className="font-Font1 ">{filter.label === 'EMP' ? 'Employee' : filter.label === 'EQP' ? 'Equipment' : filter.label}</span>

                </label>
              ))}
             

              <button
                onClick={handleApplyFilters}
  className={`mt-2 w-[80px] ml-6 px-3 py-2 rounded-md text-xs font-inter 
    ${isBothSelected ? 'bg-[#900] opacity-40 text-white' : 'bg-[#900] text-white'}`}              >
                Apply
              </button>
        
            </div>
          )}
            </div>
            </th>

            <th className="p-3 font-Font1 text-[12px] opacity-40 font-semibold tracking-[0.2px] pl-6 uppercase w-[16%] text-start">
              Total Hours
            </th>
            <th className="p-1 font-Font1 text-[12px] opacity-40 font-semibold tracking-[0.2px] uppercase w-[18%] text-start">
              Total Per Diem
            </th>
            {orderedWeekDays.map((day, index) => (
              <th
                key={day}
                className={`p-3 font-Font1 text-[12px] opacity-40 font-semibold tracking-[0.2px] uppercase text-start ${
                  index === orderedWeekDays.length - 1 ? "rounded-tr-[10px]" : ""
                }`}
              >
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              colSpan={3 + orderedWeekDays.length}
              className="p-4 text-md font-semibold text-[#000000] font-inter text-center text-gray-500"
            >
              <div className="flex items-center justify-center gap-2">
                <img src={noData} alt="No data" className="w-5 h-5" />
                <span className="text-black uppercase text-xs">No data found</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  // When data is 
  // esent – only show selected dates
  return (
    <div className="w-full flex justify-center">
      <div className="w-full rounded-[20px] max-w-full mx-2 p-3 bg-white shadow-lg overflow-x-auto custom-scrollbar">
        <table className="w-full min-w-[1000px] rounded-[20px]">
          <thead className="bg-gray-100">
            <tr className="border-b border-gray-300 text-[#900]">
              <th className="p-3 flex items-center  text-[12px] font-semibold tracking-[0.2px] uppercase w-[25%] text-left rounded-tl-[10px]">
                Employee/Equipment   
              <div className="relative z-20 " ref={dropdownRef}>
          <div
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            className="  rounded-md cursor-pointer "
          >
            <FilterAltIcon className="w-4 h-4 "  />
          </div>

          {isFilterOpen && (
<div className="fixed z-50 mt-2 bg-white shadow-md border rounded-md p-4 w-44" style={{ top: dropdownRef.current?.getBoundingClientRect().bottom + window.scrollY, left: dropdownRef.current?.getBoundingClientRect().left + window.scrollX }}>              {currentFilter.map((filter) => (
                <label key={filter.label} className="flex items-center gap-2 mb-2">
         <input
  type="checkbox"
  checked={tempSelectedFilters.includes(filter.value)}
  onChange={() => handleCheckboxChange(filter.value)}
  className="cursor-pointer"
/>


               <span className="font-Font1 ">{filter.label === 'EMP' ? 'Employee' : filter.label === 'EQP' ? 'Equipment' : filter.label}</span>

                </label>
              ))}
             

              <button
                onClick={handleApplyFilters}
  className={`mt-2 w-[80px] ml-6 px-3 py-2 rounded-md text-xs font-inter 
    ${isBothSelected ? 'bg-[#900] opacity-40 text-white' : 'bg-[#900] text-white'}`}              >
                Apply
              </button>
        
            </div>
          )}
            </div>
              </th>
                     {isSingleDaySelected && (
  <th className="p-3 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase text-start">
    Cost Code
  </th>
)}

              <th className="p-1 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[15%] text-start">Total Hours</th>
              <th className="font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[19%] text-center">Total Per Diem</th>
          {actualDateRange.map((date, index) => (
  <th
    key={date.format("YYYY-MM-DD")}
    className={`p-3 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase text-start ${
      index === actualDateRange.length - 1 ? "rounded-tr-[10px]" : ""
    }`}
  >
    {date.format("dddd")}
  </th>
))}

            </tr>
          </thead>
          <tbody>
            {Object.values(data.emp_report).map((employee, index) => {
              const { emp_name, total_perdim, total_hours, activity } = employee;
console.log(activity,'activity')
              return (
                <tr key={index} className="border-b border-gray-200">
                  <td className="p-1 font-semibold text-start">
                    <div className="flex gap-2 items-center">
                      <div>
                        <div className="flex flex-wrap items-center gap-1">
                          <span className="text-sm cursor-pointer font-Font1 font-semibold">
                            {emp_name.length > 20 ? `${emp_name.slice(0, 20)}...` : emp_name}
                          </span>
                          <span
                            className="px-2 py-[2px] font-inter text-[#8B1818] text-[12px] font-medium"
                            style={{
                              background: "rgba(139, 24, 24, 0.10)",
                              borderRadius: "9999px",
                            }}
                          >
                            {activeFilter === "EQP" && employee.activity?.[0]?.work_details?.[0]?.job_id
                              ? employee.activity[0].work_details[0].job_id
                              : employee.emp_id}
                          </span>
                        </div>
                        <div className="text-xs font-Font1 text-gray-500">{employee.classification_name}</div>
                      </div>
                    </div>
                  </td>
                  {isSingleDaySelected && (
  <td className="text-start font-inter pl-6 text-sm text-[#374151]">
    {
      activity && activity.length > 0 && activity[0].work_details && activity[0].work_details.length > 0
        ? activity[0].work_details[0].cost_code_id.toFixed(1)
        : "-"
    }
  </td>
)}

                  <td className="text-gray-900 text-center pr-14 font-inter text-sm text-[#374151]">
                    {/* {total_hours?.split(":").slice(0, 2).join(":")} */}
                      {timeToDecimal(total_hours)}
                  </td>
                  <td className="text-gray-900 text-center font-inter text-sm text-[#374151] pr-3">
                    {total_perdim ? `${total_perdim}` : "0"}
                  </td>
  {actualDateRange.map((date) => {
  const formattedDate = date.format("YYYY-MM-DD");
  const dailyActivity = activity.find((act) => act.date === formattedDate);

  // Convert "HH:MM" to total minutes
  const timeToMinutes = (timeStr) => {
    const [hrs, mins] = timeStr.split(":").map(Number);
    return hrs * 60 + mins;
  };

  // Convert minutes to "HH:MM"
  const minutesToTime = (mins) => {
    const hours = Math.floor(mins / 60);
    const minutes = mins % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };

  let totalMinutes = 0;
  if (dailyActivity?.work_details) {
    totalMinutes = dailyActivity.work_details.reduce((sum, entry) => {
      return sum + timeToMinutes(entry.hours);
    }, 0);
  }

  const combinedDailyHours = minutesToTime(totalMinutes);
const unitLabel =
  activeFilter === "EQP" && dailyActivity?.work_details
    ? dailyActivity.work_details.find((wd) => wd.unit)?.unit || null
    : null;
  return (

<td key={formattedDate} className="p-3 text-start">
  <div
    style={{ justifyContent: "center", display: "flex", alignItems: "center" }}
    className="py-1 pl-[2px] border rounded font-inter text-sm text-[#374151] w-[80px] bg-[#F9FAFB]"
  >
    <div className="flex flex-col items-center leading-tight">
      
      {/* hours */}
      <span>
        {combinedDailyHours === "00:00"
          ? "0.00 hrs"
          : `${timeToDecimal(combinedDailyHours)} hrs`}
      </span>

      {/* show unit only for EQP */}
  {dailyActivity?.work_details?.[0]?.etype === "EQP" &&
 dailyActivity?.work_details?.[0]?.unit && (
  <div
    className="text-[10px] text-gray-500 font-inter mt-[2px] text-center leading-tight w-full truncate"
    title={dailyActivity.work_details[0].unit}
  >
    {dailyActivity.work_details[0].unit}
  </div>
)}
    </div>
  </div>
</td>
  );
})}

                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportsData;
